export const VEHICLE_HISTORY_SERVICE_REQUEST_COLUMNS = ['serviceOrderId', 'serviceCaseId'] as const;
